import { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { formatUSDate, formatUSDateTime } from 'utils/intlDate'
import { IBlackoutPeriod } from 'modules/Admin/locations/Blackouts'
import Button from '../Button'

interface IBlackoutPeriodProps {
  blackoutPeriods: IBlackoutPeriod[]
  onDelete: (index: number) => void
}

export default function BlackoutPeriodsList({
  blackoutPeriods,
  onDelete
}: IBlackoutPeriodProps) {
  const [idToDelete, setIdToDelete] = useState<number | null>(null)
  const [openConfirm, setOpenConfirm] = useState<boolean>(false)

  const handleCloseConfirm = () => {
    setOpenConfirm(false)
    setIdToDelete(null)
  }

  const handleOpenConfirm = (index: number) => {
    setIdToDelete(index)
    setOpenConfirm(true)
  }

  const handleDeleteBlackout = () => {
    onDelete(idToDelete as number)
    setOpenConfirm(false)
  }

  return (
    <div className="">
      {blackoutPeriods.length > 0 ? (
        blackoutPeriods.map((blackoutPeriod, index) => (
          <div
            className="first:border-t border-b p-4 flex items-center gap-5 md:gap-3"
            key={index}
          >
            <CalendarTodayOutlinedIcon />
            <span className="flex flex-col sm:flex-row gap-1">
              <span>
                {formatUSDate(new Date(blackoutPeriod?.startDateComplete))}
              </span>
              <span className="hidden md:block">-</span>
              <span>
                {formatUSDate(new Date(blackoutPeriod?.endDateComplete))}
              </span>
            </span>
            <span className="flex flex-col sm:flex-row gap-1 lg:ml-10">
              <span>
                {formatUSDateTime(
                  new Date(
                    `${blackoutPeriod?.startDate} ${blackoutPeriod?.startTime}`
                  )
                )}
              </span>
              <span className="hidden md:block">-</span>
              <span>
                {formatUSDateTime(
                  new Date(
                    `${blackoutPeriod?.endDate} ${blackoutPeriod?.endTime}`
                  )
                )}
              </span>
            </span>
            <DeleteOutlineOutlinedIcon
              className="cursor-pointer ml-auto"
              onClick={() => handleOpenConfirm(index)}
              color="error"
            ></DeleteOutlineOutlinedIcon>
          </div>
        ))
      ) : (
        <div className="flex flex-col items-center border-t border-b py-7 gap-2">
          <div>
            <div className="bg-gray-100 py-2 px-2 rounded-full h-auto">
              <div className="bg-gray-50 py-2 px-2 rounded-full">
                <CalendarTodayOutlinedIcon />
              </div>
            </div>
          </div>
          <div className="font-semibold text-lg">No Blackout Periods found</div>
          <span className="text-center text-sm max-w-[350px]">
            Use the calendar to select dates and times for blackout periods.
            Click ‘Add Blackout Period’. Once you have added all desired
            blackout periods, click ‘Save Blackout Periods’ to confirm.
          </span>
        </div>
      )}
      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        aria-labelledby="Delete Blackout Period"
      >
        <DialogTitle id={`alert-dialog-title`}>{'Are you sure?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id={`alert-dialog-description`}>
            Are you sure you want to delete blackout period?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm}>Cancel</Button>
          <button
            className="bg-primary-500 text-white px-3 py-2 rounded-lg"
            onClick={handleDeleteBlackout}
          >
            Remove
          </button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
